import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
    StyledCard,
    StyledCardContent,
    Text,
    Span,
    KeyboardDatePicker,
    StyledFormHelperText,
    TimePicker,
    Input,
    TextField,
    ContainedButton,
    OutlinedButton,
} from '../../index';

const CreateSessionCard = ({
    errors,
    disabledTime,
    disabledDate,
    appointmentDate,
    handleDateChange,
    appointmentStartTime,
    handleStartTimeChange,
    appointmentEndTime,
    handleEndTimeChabge,
    name,
    handleNameChange,
    description,
    handleDescriptionChange,
    loading,
    onCancel,
    onSave,
}) => {
    const user = useSelector((state) => state.user);

    return (
        <StyledCard>
            <StyledCardContent>
                <Text $fontSize="20px" $bold>
                    Session Information
                </Text>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns:
                            user.staff.staff_role.name !== 'Provider'
                                ? '270px 120px 120px auto'
                                : '270px 120px 120px',
                        columnGap: '15px',
                    }}
                >
                    <KeyboardDatePicker
                        disablePast
                        id="newAppointmentDate"
                        label={
                            <Span $color="black">
                                Date <Span $color="pink">*</Span>
                            </Span>
                        }
                        value={appointmentDate}
                        onChange={(date) => handleDateChange(date)}
                        disabled={disabledDate || loading}
                    />
                    {errors.find((value) => value.property === 'appointmentDate') && (
                        <StyledFormHelperText error style={{ gridRow: '2/3', gridColumn: '1/2' }}>
                            {errors.find((value) => value.property === 'appointmentDate')?.message}
                        </StyledFormHelperText>
                    )}

                    <TimePicker
                        id="startTime"
                        label="Start time"
                        placeholder="Select"
                        value={appointmentStartTime}
                        onChange={handleStartTimeChange}
                        disabled={disabledTime || loading}
                    />

                    <TimePicker
                        id="endTime"
                        label="End time"
                        placeholder="Select"
                        value={appointmentEndTime}
                        onChange={handleEndTimeChabge}
                        disabled={disabledTime || loading}
                    />

                    <div style={{ gridRow: '2/3', gridColumn: '2/span 2' }}>
                        {errors.find((value) => value.property === 'appointmentStartTime') && (
                            <StyledFormHelperText error>
                                {
                                    errors.find(
                                        (value) => value.property === 'appointmentStartTime'
                                    )?.message
                                }
                            </StyledFormHelperText>
                        )}
                        {errors.find((value) => value.property === 'appointmentEndTime') && (
                            <StyledFormHelperText error>
                                {
                                    errors.find((value) => value.property === 'appointmentEndTime')
                                        ?.message
                                }
                            </StyledFormHelperText>
                        )}
                    </div>
                </div>
                <div>
                    <Input
                        label="Session Name"
                        required
                        placeholder="Session Name"
                        value={name}
                        onChange={handleNameChange}
                        helperText={errors.find((value) => value.property === 'name')?.message}
                        disabled={loading}
                        max={100}
                    />
                </div>
                <div>
                    <TextField
                        required
                        id="description"
                        name="description"
                        label="Description"
                        placeholder="Description"
                        value={description}
                        onChange={handleDescriptionChange}
                        helperText={
                            errors.find((value) => value.property === 'description')?.message
                        }
                        disabled={loading}
                        inputProps={{ maxLength: 2000 }}
                    />
                </div>

                {(onCancel || onSave) && (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            columnGap: '10px',
                            marginTop: '20px',
                        }}
                    >
                        {onCancel && (
                            <OutlinedButton onClick={onCancel} $width="80px">
                                Cancel
                            </OutlinedButton>
                        )}
                        {onSave && (
                            <ContainedButton onClick={onSave} $width="90px">
                                Save
                            </ContainedButton>
                        )}
                    </div>
                )}
            </StyledCardContent>
        </StyledCard>
    );
};

CreateSessionCard.propTypes = {
    errors: PropTypes.arrayOf(PropTypes.object),
    disabledTime: PropTypes.bool,
    disabledDate: PropTypes.bool,
    appointmentDate: PropTypes.object,
    handleDateChange: PropTypes.func,
    appointmentStartTime: PropTypes.string,
    handleStartTimeChange: PropTypes.func,
    appointmentEndTime: PropTypes.string,
    handleEndTimeChabge: PropTypes.func,
    name: PropTypes.string,
    handleNameChange: PropTypes.func,
    description: PropTypes.string,
    handleDescriptionChange: PropTypes.func,
    loading: PropTypes.bool,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
};

export default CreateSessionCard;
